import React from "react"
import { LayoutStep } from "./layout"
import { LocationStep } from "./location"
import { PinsStep } from "./pins"
import { StyleStep } from "./style"
import { BorderStep } from "./border";
import { SizeStep } from "./size";
import { SubmitStep } from "./submit"
import { Box, List, useTheme } from "@mui/material"
import { useStep } from "../../../state/map"

interface StepsProps {
  excludeSubmit?: boolean;
}

export const Steps = ({ excludeSubmit = false }: StepsProps) => {
  const theme = useTheme();
  const step = useStep();
  return (
    <Box sx={{ width: "100%"}}>
      <List
        sx={{ width: '100%', bgcolor: theme.palette.background.default, p: 0, borderLeft: "none" }}
        aria-labelledby="nested-list-subheader"
      >
      { //<div style={{ display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: theme.palette.secondary.dark }}>
      }
        <LocationStep expanded={step === "location"} />
        <PinsStep expanded={step === "pins"} />
        <StyleStep expanded={step === "style"} />
        <LayoutStep expanded={step === "layout"} />
        <BorderStep expanded={step === "border"} />
        <SizeStep expanded={step === "size"} />
        {!excludeSubmit && <SubmitStep />}
      </List>
    </Box>
  );
}
